<button
  (click)="downloadData()"
  [disabled]="isDownloadingData"
  class="button is-small has-icon"
  data-testid="export-table-contents-btn"
  [attr.data-filename]="filename || null"
  [attr.aria-label]="reportName ? lang.tra('g9_export') + ' ' + reportName : null">
  <span class="icon"><i class="fas fa-table"></i></span>
  <span><tra slug="g9_export"></tra></span>
</button>
<span
  *ngIf="hasNothingToExport"
  class="is-size-7 has-text-grey"
  role="status"
  data-testid="export-table-contents-empty">
  <tra slug="msg_no_results"></tra>
</span>
